import { Config } from "@pandacss/dev";
export const conditions: Config["conditions"] = {
  extend: {
    notDisabled: "&:not(:disabled, [disabled], [data-disabled])",
    aromaticonChildren: "& > [class^='aromaticon-'], [class*=' aromaticon-']",
    withinWhiteLabelTheme: '[data-panda-theme="whiteLabel"] &',
    lowContrast:
      '[data-color-contrast="low"] & , &:is([data-color-contrast="low"])', // careful: the whitespace is important
    highContrast:
      '[data-color-contrast="high"] & , &:is([data-color-contrast="high"])', // careful: the whitespace is important
  },
};
